import { AfterViewInit, Directive, ElementRef, inject, output } from "@angular/core";

@Directive({
    selector: "[packboImageLoading]"
})
export class ImageLoadingDirective implements AfterViewInit {
    protected readonly allImagesLoaded = output<boolean>();

    private readonly el = inject(ElementRef<HTMLElement>);
    private images: HTMLImageElement[] = [];
    private loadedCount = 0;
    private expectedCount = 0;

    public ngAfterViewInit(): void {
        const allImages = Array.from(this.el.nativeElement.querySelectorAll("img")) as HTMLImageElement[];

        const uniqueImages = allImages.filter((img, index, arr) => {
            const firstIndex = arr.findIndex((otherImg) => otherImg.src === img.src);
            return firstIndex === index;
        });

        this.images = uniqueImages;
        this.expectedCount = this.images.length;

        if (this.expectedCount === 0) {
            this.allImagesLoaded.emit(true);
            return;
        }

        this.images.forEach((img, _) => {
            if (img.complete && img.naturalWidth > 0) {
                this.loadedCount++;
            } else {
                img.addEventListener("load", () => this.onImageLoad());
                img.addEventListener("error", () => this.onImageError());
            }
        });

        if (this.loadedCount === this.expectedCount) {
            this.allImagesLoaded.emit(true);
        }
    }

    private onImageLoad(): void {
        this.loadedCount++;

        if (this.loadedCount === this.expectedCount) {
            this.allImagesLoaded.emit(true);
        }
    }

    private onImageError(): void {
        this.loadedCount++;

        if (this.loadedCount === this.expectedCount) {
            this.allImagesLoaded.emit(true);
        }
    }
}
